export const OPS_ABILITY = [
    { subject: "dashboard", action: "manage" },
    { subject: "brands", action: "manage" },
    { subject: "settings", action: "manage" },
    { subject: "guide", action: "manage" },
    { subject: "disbursements", action: "manage" },
    { subject: "debit-notes", action: "manage" },
    { subject: "publishers", action: "manage" },
    { subject: "contracts", action: "manage" }
];
